import { List } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import Actions from '@/components/kol/common/kol-cooperation-detail-drawer/contact-info/actions'
import { CustomizedField } from '@/types/schema/directory/kol-management'

interface CustomizedFieldItemProps {
  item: CustomizedField
  onEdit: VoidFunction
}

const CustomizedFieldItem: FunctionComponent<CustomizedFieldItemProps> = ({
  item,
  onEdit,
}) => {
  return (
    <List.Item>
      <Wrapper>
        <div>{item.field_name}</div>
        <div>{item.field_value}</div>
        <Actions onEdit={onEdit} />
      </Wrapper>
    </List.Item>
  )
}

export default CustomizedFieldItem

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 40px;
  color: ${({ theme }): string => theme.colors.text.primary};

  > :last-child {
    margin-left: auto;
  }
  &:hover {
    > :last-child {
      visibility: visible;
    }
  }
`
